import React, { useState, useCallback } from "react";
import Collapse from "_c/Collapse";
import PT from "prop-types";
import Service from "../Service";

const SpecContainer = (props) => {
  const [isOpen, setIsOpen] = useState(true);
  const toggleOpen = useCallback(() => {
    setIsOpen((open) => !open);
  }, []);
  return (
    <div style={{ marginBottom: "15px" }}>
      <Collapse isOpen={isOpen} onClick={toggleOpen} title={props.spec.title}>
        <ul>
          {props.titles.map(({ title, masters, avgPrice }) => (
            <Service
              basket={props.basket}
              avgPrice={avgPrice}
              key={title}
              title={title}
              masters={masters}
            />
          ))}
        </ul>
      </Collapse>
    </div>
  );
};
SpecContainer.propTypes = {
  spec: PT.object,
  titles: PT.array,
};

export default SpecContainer;
